import type { ImgHTMLAttributes } from "react";
import iconImage from "@/assets/icon.png";
import { useBranding } from "@/hooks/useBranding";
import { cn } from "@/lib/utils";

type CoachIconProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src">;

/** The canonical AI Coach identity used by chat, navigation, and coach actions. */
export function CoachIcon({ className, alt = "", ...props }: CoachIconProps) {
  const { branding } = useBranding();
  const src = branding?.chatIdleIconUrl || iconImage;

  return (
    <img
      src={src}
      alt={alt}
      className={cn("shrink-0 rounded-full object-cover", className)}
      {...props}
    />
  );
}
